class CartDrawer {
  constructor() {
    this.selectors = {
      drawer: '.c-cart-drawer__minicart-wrapper',
      backdrop: '.c-cart-drawer__minicart-backdrop',
      container: '.c-cart-drawer__minicart-container',
      closeButton: '.c-cart-drawer__minicart-close',
      clearAllButton: '.c-cart-drawer__minicart-clear-all',
      itemList: '.c-cart-drawer__minicart-content .c-cart-drawer__minicart-top ol',
			itemHiddenTitle: '[data-item-title]',
      cartItemTemplate: '.c-cart-drawer__minicart-item',
      quantityInput: '.c-cart-drawer__minicart-item-quantity',
      quantityPlus: '.c-cart-drawer__minicart-item-quantity-plus',
      quantityMinus: '.c-cart-drawer__minicart-item-quantity-minus',
      itemRemove: '.c-cart-drawer__minicart-item-remove',
      subtotalPrice: '.c-cart-drawer__subtotal-price .money',
      countItem: '.c-cart-drawer__count-item',
      countItemLabel: '.c-cart-drawer__count-item-label',
      emptyCart: '.c-cart-drawer__minicart-empty',
      checkoutButton: '.c-cart-drawer__checkout-btn'
    };

    this.drawer = document.querySelector(this.selectors.drawer);
    if (!this.drawer) return;
    
    this.backdrop = this.drawer.querySelector(this.selectors.backdrop);
    this.container = this.drawer.querySelector(this.selectors.container);
    this.itemList = this.drawer.querySelector(this.selectors.itemList);
    this.closeButton = this.drawer.querySelector(this.selectors.closeButton);
    this.clearAllButton = this.drawer.querySelector(this.selectors.clearAllButton);
    this.subtotalPrice = this.drawer.querySelector(this.selectors.subtotalPrice);
    this.countItem = this.drawer.querySelector(this.selectors.countItem);
    this.countItemLabel = this.drawer.querySelector(this.selectors.countItemLabel);
    this.emptyCart = this.drawer.querySelector(this.selectors.emptyCart);

    // フォーマットマネー用のユーティリティ
    this.moneyFormat = '¥{{amount}}';
    
    this._bindEvents();
  }

  _bindEvents() {
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this._closeDrawer.bind(this));
    }

    if (this.backdrop) {
      this.backdrop.addEventListener('click', this._closeDrawer.bind(this));
    }

    if (this.clearAllButton) {
      this.clearAllButton.addEventListener('click', this._clearCart.bind(this));
    }

    this.drawer.addEventListener('click', this._handleQuantityChange.bind(this));
    this.drawer.addEventListener('click', this._handleItemRemove.bind(this));
    
    // // 「カートに追加」ボタンがクリックされた時に自動的にカートドロワーを開く
    // theme.jsでトリガー
    // document.addEventListener('click', (e) => {
    //   if (e.target.matches('[data-add-to-cart]') || e.target.closest('[data-add-to-cart]')) {
    //     setTimeout(this._openDrawer.bind(this), 500);
    //   }
    // });
    
    // [data-cart-drawer-opener]がクリックされた時にカートドロワーを開く
    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-cart-drawer-opener]') || e.target.closest('[data-cart-drawer-opener]')) {
        e.preventDefault();
        this._openDrawer();
      }
    });
  }

  _closeDrawer(evt) {
    evt && evt.preventDefault();
    this.drawer.classList.remove('c-cart-drawer__minicart-active');
  }

  _openDrawer() {
    // カート情報を取得して表示を更新
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        this._updateCartDrawer(cart);
        this.drawer.classList.add('c-cart-drawer__minicart-active');
      })
      .catch(error => console.error('カート情報の取得に失敗しました:', error));
  }

  _clearCart(evt) {
    evt && evt.preventDefault();
    
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(cart => {
        this._updateCartDrawer(cart);
        this._updateCartCountBubble(0);
      })
      .catch(error => {
        console.error('カートのクリアに失敗しました:', error);
      });
  }

  _handleQuantityChange(evt) {
    if (evt.target.matches(this.selectors.quantityPlus) || evt.target.matches(this.selectors.quantityMinus)) {
      evt.preventDefault();
      
      const quantityWrapper = evt.target.closest('.c-cart-drawer__minicart-item-quantity-wrapper');
      if (!quantityWrapper) return;
      
      const input = quantityWrapper.querySelector(this.selectors.quantityInput);
      const currentValue = parseInt(input.value, 10);
      let newValue = currentValue;
      
      if (evt.target.matches(this.selectors.quantityPlus)) {
        newValue = currentValue + 1;
      } else if (evt.target.matches(this.selectors.quantityMinus)) {
        newValue = Math.max(0, currentValue - 1);
      }

			if(newValue > 3){
				const itemTitle = quantityWrapper.querySelector(this.selectors.itemHiddenTitle);
				alert( `${itemTitle ? itemTitle.textContent : 'この商品'}は3点までしか購入できません。`);
				input.value = currentValue;

				if(currentValue > 3){
					input.value = 3;
					this._updateItemQuantity(input);
				}
				return;
			}
      
      if (newValue !== currentValue) {
        input.value = newValue;
        this._updateItemQuantity(input);
      }
    }
  }

  _updateItemQuantity(input) {
    const variantId = input.getAttribute('data-variant-key');
    const newQuantity = parseInt(input.value, 10);
    
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: newQuantity
      })
    })
      .then(response => response.json())
      .then(cart => {

        if(cart.status === 422) {
          alert("在庫が不足しているか、購入するための条件を満たしておりません。");
          fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              this._updateCartDrawer(cart);
              this._updateCartCountBubble(cart.item_count);
            })
            .catch(error => {
              console.error('カート情報の取得に失敗しました:', error);
            });
        }else{
          this._updateCartDrawer(cart);
          this._updateCartCountBubble(cart.item_count);
        }
      })
      .catch(error => {
        console.error('カートの更新に失敗しました:', error);
      });
  }

  _handleItemRemove(evt) {
    const removeButton = evt.target.closest(this.selectors.itemRemove);
    if (removeButton) {
      evt.preventDefault();
      
      const item = removeButton.closest(this.selectors.cartItemTemplate);
      const input = item.querySelector(this.selectors.quantityInput);
      const variantId = input.getAttribute('data-variant-key');
      
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 0
        })
      })
        .then(response => response.json())
        .then(cart => {
          this._updateCartDrawer(cart);
          this._updateCartCountBubble(cart.item_count);
        })
        .catch(error => {
          console.error('アイテムの削除に失敗しました:', error);
        });
    }
  }

  _updateCartCountBubble(itemCount) {
    // ヘッダーのカート数バッジを更新
    const cartCountBubble = document.querySelector('[data-cart-count-bubble]') || document.querySelector('#CartCount');
    const cartCount = cartCountBubble ? cartCountBubble.querySelector('[data-cart-count]') : null;
    
    if (cartCountBubble && cartCount) {
      if (itemCount > 0) {
        cartCountBubble.classList.remove('hide');
        cartCount.textContent = itemCount;
      } else {
        cartCountBubble.classList.add('hide');
        cartCount.textContent = '';
      }
    }
  }
  
  // 金額をフォーマットするヘルパーメソッド
  _formatMoney(cents) {
    // theme.Currency.formatMoneyがある場合はそちらを使用
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, this.moneyFormat).replace(".00","");
    }
    
    // フォールバック: 独自に実装
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = this.moneyFormat;
    
    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      
      if (isNaN(number) || number == null) {
        return 0;
      }
      
      number = (number / 100.0).toFixed(precision);
      
      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsAmount = parts[1] ? (decimal + parts[1]) : '';
      
      return dollarsAmount + centsAmount;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
    }
    
    return formatString.replace(placeholderRegex, value);
  }

  _updateCartDrawer(cart) {
    // 合計金額を更新
    if (this.subtotalPrice) {
      this.subtotalPrice.innerHTML = this._formatMoney(cart.items_subtotal_price);
    }
    
    // カートアイテム数を更新
    if (this.countItem) {
      this.countItem.textContent = cart.item_count;
      
      // アイテムラベルの単数形/複数形を更新
      if (this.countItemLabel) {
        this.countItemLabel.textContent = cart.item_count === 1 ? 'アイテム' : 'アイテム';
      }
    }
    
    // カートが空の場合の表示切り替え
    if (cart.item_count === 0) {
      if (this.itemList) {
        this.itemList.innerHTML = '';
      }
      if (this.emptyCart) {
        this.emptyCart.style.display = 'block';
      }
    } else {
      if (this.emptyCart) {
        this.emptyCart.style.display = 'none';
      }
      this._renderCartItems(cart.items);
    }
  }

  _renderCartItems(items) {
    if (!this.itemList) return;
    
    let html = '';
    
    items.forEach(item => {
      const itemHtml = `
        <li class="c-cart-drawer__minicart-item c-cart-drawer__minicart-item-${item.variant_id}">
          <a href="${item.url}" title="${item.title}" class="c-cart-drawer__minicart-item-image">
            <img
              src="${item.featured_image ? item.featured_image.url : ''}"
              alt="${item.title}"
              width="90"
              height="90"
            >
          </a>
          <div class="c-cart-drawer__minicart-item-details">
						<span class="hide" hidden data-item-title>${item.title}</span>
            <div class="c-cart-drawer__minicart-item-details-inner">
              <div class="c-cart-drawer__minicart-item-group-title">
                <p class="c-cart-drawer__minicart-item-name">
                  <a href="${item.url}">${item.product_title}</a>
                </p>
                <p class="c-cart-drawer__minicart-item-vendor">${item.vendor}</p>
                <div class="c-cart-drawer__minicart-item-options">
                  ${this._renderOptions(item)}
                </div>
                <div title="このアイテムを削除" class="c-cart-drawer__minicart-item-remove">
                  <span class="c-cart-drawer__minicart-item-remove-icon"></span>
                  <span class="c-cart-drawer__minicart-item-remove-text">×</span>
                </div>
              </div>
              <div class="c-cart-drawer__minicart-item-group-price">
                <div class="c-cart-drawer__minicart-item-price">
                  <span class="money">${this._formatMoney(item.price)}</span>
                </div>
                <div class="c-cart-drawer__minicart-item-collateral">
                  <div class="c-cart-drawer__minicart-item-quantity-wrapper">
                    <button data-minus-qtt="" class="c-cart-drawer__minicart-item-quantity-minus">-</button>
                    <input
                      class="c-cart-drawer__minicart-item-quantity"
                      type="number"
                      name="updates[]"
											disabled
                      data-current-qty="${item.quantity}"
                      value="${item.quantity}"
                      min="0"
                      aria-label="アイテム数量"
                      data-variant-key="${item.key}"
                    >
                    <button data-plus-qtt="" class="c-cart-drawer__minicart-item-quantity-plus">+</button>
                  </div>
                  <span class="c-cart-drawer__minicart-item-line">x</span>
                  <span class="c-cart-drawer__minicart-item-price">
                    <span class="money">${this._formatMoney(item.price)}</span>
                  </span>
                </div>
                <div class="c-cart-drawer__minicart-item-sub-total-price">
                  <span class="money">${this._formatMoney(item.line_price)}</span>
                </div>
              </div>
            </div>
          </div>
        </li>
      `;
      
      html += itemHtml;
    });
    
    this.itemList.innerHTML = html;
  }

  _renderOptions(item) {
    let optionsHtml = '';
    
    if (item.options_with_values && item.options_with_values.length) {
      item.options_with_values.forEach(option => {
        if (option.value && option.value !== 'Default Title') {
          optionsHtml += `
            <div class="c-cart-drawer__minicart-item-option-element">
              <span class="c-cart-drawer__minicart-item-option-name">${option.name}:</span>
              <span class="c-cart-drawer__minicart-item-option-value">${option.value}</span>
            </div>
          `;
        }
      });
    }
    
    return optionsHtml;
  }

  init() {
    // カートドロワーを初期化
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        this._updateCartDrawer(cart);
        this._updateCartCountBubble(cart.item_count);
      })
      .catch(error => {
        console.error('カート情報の取得に失敗しました:', error);
      });
  }
}

// DOM読み込み後にカートドロワーを初期化
document.addEventListener('DOMContentLoaded', function() {
  const cartDrawer = new CartDrawer();
  cartDrawer.init();
});
